<template>
  <div class="pagination-wrapper">
    <el-pagination
      :hide-on-single-page="hideIfSingle"
      :layout="layout"
      background
      :page-sizes="[3, 5, 10, 20, 50, 100]"
      :total="total"
      :page-size="pageSize"
      :current-page.sync="current"
      @size-change="handleChangeSize"
      @current-change="handleChangePage"
    >
    </el-pagination>
    <div v-if="total && total < pageSize" class="one-page">
      共 {{ total }} 条
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    hideIfSingle: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 50,
    },
    total: {
      type: Number,
      default: 0,
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
  },
  data() {
    return {
      current: this.currentPage,
    };
  },
  watch: {
    currentPage(val) {
      this.current = val;
    },
  },
  methods: {
    handleChangePage(current) {
      this.$emit("change-page", current);
    },
    handleChangeSize(size) {
      this.$emit("change-size", size);
    },
  },
};
</script>

<style lang="less" scoped>
.pagination-wrapper {
  margin-top: 10px;
}
.one-page {
  font-size: 13px;
}
</style>
